import { type Locale } from "~/features/i18n/utils";
import { translations as fieldTranslations } from "~/features/ui/form/translations";
export function useFields(locale: Locale) {
  const fields = [{
    name: "Email",
    type: "email",
    placeholder: `${fieldTranslations["email"]["placeholder"][locale]} *`,
    required: true,
    pattern: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
    message: fieldTranslations["email"]["error"][locale]
  }];
  return fields;
}
export type FormValues = { [K in ReturnType<typeof useFields>[number]["name"]]: string };